export const initialValues = {
    departure: {
        value: '',
        label: '',
        id: '',
        nmAeroporto: '',
        tpDestino: '',
        cdLatitude: '',
        cdLongitude: '',
        sgIata: '',
    },
    destination: {
        value: '',
        label: '',
        id: '',
        nmRegiao: '',
        tpDestino: '',
        cdLatitude: '',
        cdLongitude: '',
        sgIata: '',
    },
    dateRange: [null, null],
    adults: 1,
    children: 0,
    qntRoom: [{ qtnAdt: 2, qtdInf: 0, idadeInfant: [] }],
};
export const buildQueryUrl = (values, environment) => {
    var _a, _b;
    const { departure, destination, dateRange, qntRoom, children } = values;
    const totalAdults = qntRoom.reduce((total, room) => total + room.qtnAdt, 0);
    const totalChildren = qntRoom.reduce((total, room) => total + room.qtdInf, 0);
    const destinParam = destination.tpDestino === 'A'
        ? {
            destin: destination.sgIata,
            destinId: destination.id,
            destinName: destination.label,
            destinType: destination.tpDestino,
        }
        : {
            hotel: destination.id.toString(),
            destinName: destination.label,
            destinType: destination.tpDestino,
        };
    const queryObject = Object.assign({ origin: departure.tpDestino === 'A' ? departure.sgIata : departure.value, originId: departure.id, originExternalId: '', originName: departure.nmAeroporto || (departure === null || departure === void 0 ? void 0 : departure.label), destinExternalId: '', coordenadasOrigin: [
            typeof departure.cdLatitude === 'string'
                ? parseFloat(departure.cdLatitude)
                : departure.cdLatitude,
            typeof departure.cdLongitude === 'string'
                ? parseFloat(departure.cdLongitude)
                : departure.cdLongitude,
        ], coordenadasDestin: [
            typeof destination.cdLatitude === 'string'
                ? parseFloat(destination.cdLatitude)
                : destination.cdLatitude,
            typeof destination.cdLongitude === 'string'
                ? parseFloat(destination.cdLongitude)
                : destination.cdLongitude,
        ], originType: departure.tpDestino, dataIni: (_a = dateRange[0]) === null || _a === void 0 ? void 0 : _a.toISOString().split('T')[0], dataFim: (_b = dateRange[1]) === null || _b === void 0 ? void 0 : _b.toISOString().split('T')[0], qtnAdt: totalAdults.toString(), qtdInf: totalChildren.toString(), idadeInfant: children > 0
            ? Array.from({ length: children }, (_, i) => (3 + i).toString())
            : [], qntBebe: '0', idadeBebe: [], qntRoom: qntRoom.map((room) => ({
            qtnAdt: room.qtnAdt.toString(),
            qtdInf: room.qtdInf.toString(),
            idadeInfant: room.idadeInfant.map((age) => age.toString()),
            qntBebe: '0',
            idadeBebe: [],
        })), searchType: 'ALL', flightType: 'roundTrip', utm_campaign: 'search', utm_source: 'Smiles' }, destinParam);
    const queryString = encodeURIComponent(JSON.stringify(queryObject));
    const baseUrls = {
        develop: 'https://dev.smilesviagens.com.br/v2/checkout/search',
        homol: 'https://hml.smilesviagens.com.br/v2/checkout/search',
        preprod: 'https://preprd.smilesviagens.com.br/v2/checkout/search',
        production: 'https://www.smilesviagens.com.br/v2/checkout/search',
    };
    console.log('URL', `${baseUrls[environment] || baseUrls.dev}?query=${queryString}`);
    return `${baseUrls[environment] || baseUrls.dev}?query=${queryString}`;
};
//# sourceMappingURL=BuildQueryUrl.js.map